module.exports = __webpack_public_path__ + "img/empty_data_imgtxt.f7ed1c29.svg";